import { useParams } from '@exam-management/router';
import { mappedQSetReviewSubtaskStatus, StartTaskSection } from '@exam-management/task-management';

import { useQSetReviewSubtask } from '../../providers';
import { getQSetSubtaskStartSectionVariant } from '../../utils';
import { StartSubtaskButton } from '../start-subtask-button';

export default function QSetReviewSubtaskStartSection() {
  const { subTaskId } = useParams('/task-management/qset-review/:taskId/subtask/:subTaskId');
  const { status, roles } = useQSetReviewSubtask();
  const taskStatus =
    mappedQSetReviewSubtaskStatus[status.code as keyof typeof mappedQSetReviewSubtaskStatus];
  const variant = getQSetSubtaskStartSectionVariant(roles, taskStatus);

  if (variant === null || variant === 'HIDDEN') {
    return null;
  }

  return (
    <StartTaskSection
      description='คลิกที่ปุ่ม “Start Task” เพื่อเริ่มพัฒนาข้อสอบ'
      action={<StartSubtaskButton taskId={subTaskId} />}
    />
  );
}
